<template>
	<div class="category">
		<form @submit.prevent="getList">
			<ManagingSection>
				<ManagingBox title="기간">
					<DateRange
						v-model="dateRange"
						:dateRange="dateRange"
						type="date"
					/>
				</ManagingBox>
				<div class="btn-wrap-main">
					<button
						class="btn-main blue"
						type="submit"
						@click="getList"
					>
						검색하기
					</button>
					<button
						class="btn-main border"
						type="button"
						@click="searchInit"
					>
						초기화
					</button>
				</div>
			</ManagingSection>
		</form>
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left"></div>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>1차 카테고리</th>
						<th>2차 카테고리</th>
						<th>3차 카테고리</th>
						<th>제품 등록수</th>
						<th>리뷰 작성수</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="group in groupedData">
						<template
							v-for="(subcategory, sIndex) in group.subcategories"
						>
							<tr
								v-for="(item, index) in subcategory.items"
								:key="item.idThirdCategory"
							>
								<td
									v-if="sIndex === 0 && index === 0"
									:rowspan="
										group.subcategories.reduce(
											(total, sub) =>
												total + sub.items.length,
											0
										)
									"
								>
									<div class="category__first">
										<span class="category__name">{{
											group.name || 'NONE'
										}}</span>
										<span
											>제품:
											{{
												group.productSum.toLocaleString() ||
												'-'
											}}</span
										>
										<span
											>리뷰:
											{{
												group.reviewSum.toLocaleString() ||
												'-'
											}}</span
										>
									</div>
								</td>
								<td
									v-if="index === 0"
									:rowspan="subcategory.items.length"
								>
									{{ subcategory.name || 'NONE' }} ({{
										item.idSecondCategory || '-'
									}})
								</td>
								<td>
									{{ item.thirdCategoryText || '-' }} ({{
										item.idThirdCategory || '-'
									}})
								</td>
								<td>
									{{
										item.productCount.toLocaleString() ||
										'-'
									}}
								</td>
								<td>
									{{
										item.reviewCount.toLocaleString() || '-'
									}}
								</td>
							</tr>
						</template>
					</template>
				</tbody>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange.vue';
	import * as XLSX from 'xlsx';
	import moment from 'moment';

	export default {
		components: {
			ManagingSection,
			ManagingBox,
			DateRange,
		},
		data() {
			return {
				list: [],
				groupedData: [],
				dateRange: {
					from: '',
					to: '',
				},
			};
		},
		mounted() {
			this.getList();
		},
		computed: {
			startDate() {
				return moment(this.dateRange.from).format('YYYYMMDD');
			},
			endDate() {
				return moment(this.dateRange.to).format('YYYYMMDD');
			},
		},
		methods: {
			async getList() {
				if (!this.validation()) {
					return false;
				}
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/operation/statistic/category?startDate=${Number(this.startDate) || ''}&endDate=${Number(this.endDate) || ''}`
					);
					this.list = data;
					this.groupData();
				} catch (error) {
					console.error(error);
					alert('데이터를 불러오는데 실패했습니다.');
				}
			},
			validation() {
				const startDate = moment(this.dateRange.from).valueOf();
				const endDate = moment(this.dateRange.to).valueOf();
				if (startDate > endDate) {
					alert('종료일은 시작일 이전이 될 수 없습니다.');
					this.dateRange = {
						from: '',
						to: '',
					};
					return;
				}
				return true;
			},
			excelDown() {
				const ws = XLSX.utils.aoa_to_sheet(this.formatTableData());
				const merges = this.generateMerges();

				ws['!merges'] = merges;

				const wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
				const fileName = `글로우픽_카테고리통계_${new Date().getTime()}(${this.dateRange.from || '_'}~${this.dateRange.to || '_'}).xlsx`;
				XLSX.writeFile(wb, fileName);
			},
			formatTableData() {
				const header = [
					[
						'1차 카테고리',
						'2차 카테고리',
						'3차 카테고리',
						'제품 등록수',
						'리뷰 작성수',
					],
				];
				const body = [];

				this.groupedData.forEach(group => {
					let firstCategory = group.name || 'NONE';
					let productSum = group.productSum;
					let subcategories = group.subcategories;

					subcategories.forEach(subcategory => {
						let secondCategory = subcategory.name || 'NONE';

						subcategory.items.forEach(item => {
							body.push([
								firstCategory,
								`${secondCategory} (${item.idSecondCategory || '-'})`,
								`${item.thirdCategoryText || '-'} (${item.idThirdCategory || '-'})`,
								item.productCount.toLocaleString() || '-',
								item.reviewCount.toLocaleString() || '-',
							]);
						});
					});
				});
				return header.concat(body);
			},
			generateMerges() {
				const merges = [];
				let rowIndex = 1;

				this.groupedData.forEach(group => {
					const groupRowCount = group.subcategories.reduce(
						(total, sub) => total + sub.items.length,
						0
					);
					merges.push({
						s: { r: rowIndex, c: 0 },
						e: { r: rowIndex + groupRowCount - 1, c: 0 },
					});

					group.subcategories.forEach(subcategory => {
						const subcategoryRowCount = subcategory.items.length;
						merges.push({
							s: { r: rowIndex, c: 1 },
							e: { r: rowIndex + subcategoryRowCount - 1, c: 1 },
						});
						rowIndex += subcategoryRowCount;
					});
				});

				return merges;
			},
			searchInit() {
				this.dateRange = {
					from: '',
					to: '',
				};
				this.getList();
			},
			groupData() {
				const categoryMap = this.list.reduce((acc, item) => {
					if (!acc[item.firstCategoryText]) {
						acc[item.firstCategoryText] = {
							name: item.firstCategoryText,
							totalCount: 0,
							subcategories: {},
							productSum: 0,
							reviewSum: 0,
						};
					}
					if (
						!acc[item.firstCategoryText].subcategories[
							item.secondCategoryText
						]
					) {
						acc[item.firstCategoryText].subcategories[
							item.secondCategoryText
						] = {
							name: item.secondCategoryText,
							totalCount: 0,
							items: [],
						};
					}
					acc[item.firstCategoryText].subcategories[
						item.secondCategoryText
					].items.push(item);
					acc[item.firstCategoryText].subcategories[
						item.secondCategoryText
					].totalCount += 1;
					acc[item.firstCategoryText].productSum +=
						item.productCount || 0;
					acc[item.firstCategoryText].reviewSum +=
						item.reviewCount || 0;
					return acc;
				}, {});

				const groupedData = Object.values(categoryMap).map(group => {
					group.totalCount = Object.values(
						group.subcategories
					).reduce(
						(total, subcategory) => total + subcategory.totalCount,
						0
					);
					group.subcategories = Object.values(
						group.subcategories
					).map(subcategory => ({
						name: subcategory.name,
						totalCount: subcategory.totalCount,
						items: subcategory.items,
					}));
					return group;
				});

				this.groupedData = groupedData;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.category {
		&__first {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		}
		&__name {
			font-size: 20px;
			font-weight: bold;
		}
	}
</style>
